import React from 'react';
import { Provider } from 'react-redux';
import MyRoutes from './Routes/MyRouter';
import { store } from './State/Store';
import TimeAgo from "javascript-time-ago";
import ar from "javascript-time-ago/locale/ar";
import ReactGA from "react-ga"


const TrackingID = 'G-K09EE327BD'

ReactGA.initialize(TrackingID)

const App:  React.FC = () => {

    TimeAgo.addDefaultLocale(ar);
  return (

    <Provider store={store}>
      <MyRoutes />
    </Provider>

  );
}







export default App;
